import * as React from "react";
import type { SVGProps } from "react";
const SvgClose = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M5.637 4.223a1 1 0 0 0-1.414 1.414L10.587 12l-6.364 6.364a1 1 0 1 0 1.414 1.414L12 13.415l6.364 6.364a1 1 0 1 0 1.414-1.414L13.415 12l6.364-6.364a1 1 0 0 0-1.414-1.414L12 10.587z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgClose;
